import React from 'react';
import PropTypes from 'prop-types';
import GlideCarousel from '../../../../../website/components/stateless/GlideCarousel';
import style from './CTA.scss';

const CTACarousel = ({ callouts, numItems }) => {
  const carouselItems = callouts.slice(0, numItems).map(({ image, header, content }, index) => (
    <React.Fragment key={index}>
      <div>{image}</div>
      <div className={style.carouselHeader}>{header}</div>
      <div>{content}</div>
    </React.Fragment>
  ));

  const controls = parseInt(numItems, 10) === 1;

  const carouselProps = {
    withoutControls: controls,
  };

  return (
    <div className={style.carousel}>
      <GlideCarousel {...carouselProps}>
        {carouselItems}
      </GlideCarousel>
    </div>
  );
};

CTACarousel.propTypes = {
  callouts: PropTypes.array.isRequired,
  numItems: PropTypes.string.isRequired,
};

export default CTACarousel;
